import { CS_BASE_URL, CS_INBOX } from './config'
import { createVisitor, visitorExists } from './api'

// 匿名访客身份存在当前浏览器里：关掉页面再来还是同一个访客、同一个会话；清了浏览器数据就是新访客
const STORAGE_KEY = 'pg_cs_visitor'

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null')
  } catch (e) {
    return null
  }
}

const write = value => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value))
  } catch (e) {
    // 无痕模式等存不了：本次照常用，下次打开算新访客
  }
}

// 这个浏览器以前联系过客服（有访客身份）
export const hasCachedVisitor = () => {
  const cached = read()
  return Boolean(cached && cached.baseUrl === CS_BASE_URL && cached.inbox === CS_INBOX && cached.sourceId)
}

export const clearVisitor = () => {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    // 忽略
  }
}

// 拿到可用的访客身份 { sourceId, pubsubToken }：有缓存且还在就用缓存，否则新建
export async function getVisitor() {
  const cached = read()
  if (
    cached &&
    cached.baseUrl === CS_BASE_URL &&
    cached.inbox === CS_INBOX &&
    cached.sourceId &&
    cached.pubsubToken &&
    (await visitorExists(cached.sourceId))
  ) {
    return cached
  }
  const created = await createVisitor()
  const visitor = {
    baseUrl: CS_BASE_URL,
    inbox: CS_INBOX,
    sourceId: created.source_id,
    pubsubToken: created.pubsub_token
  }
  write(visitor)
  return visitor
}
